var exports = {
  "kL": "xa15a2ab7--3e68fc--container",
  "WH": "xa15a2ab7--3e68fc--anchor-next",
  "Kp": "xa15a2ab7--3e68fc--anchor-icon",
  "UE": "xa15a2ab7--3e68fc--arrow",
};

module.exports = exports;
